<template>
<div v-if="items">
	<div class="generalTableClass table-responsive-true">
		<b-table :items="dataSource" :fields="columns" hover="hover" striped="striped" bordered="bordered">
			<!-- EMPTY SLOT FOR TABLE -->
			<template slot="empty" slot-scope="scope">
				<h4>{{ $t('empty') }}</h4>
			</template>

			<template slot="id" slot-scope="data">
				{{ data.index + 1 }}
			</template>
			<template slot="artikul" slot-scope="data">
				{{ data.item.artikul }}
			</template>
			<template slot="color" slot-scope="data">
				{{ data.item.color }}
			</template>
			<template slot="size" slot-scope="data">
				{{ data.item.size }}
			</template>
			<template slot="realBalance" slot-scope="data">
				{{ data.item.realBalance>0 ? data.item.realBalance : 0 }}
			</template>
			<template slot="sectorId" slot-scope="data">
				<span>{{ setSector(data.item.sectorId) }}</span>
			</template>
			<template slot="itemName" slot-scope="data">
				<span v-if="data.item.wrapped" style="color: blue;"><strong><b>Уп.</b>  - </strong>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
				<span v-else>{{ data.value ? data.value.substring(0, 30) : '-' }}</span>
			</template>
			<template slot="count" slot-scope="data">
				<b-form-input :ref="data.index + '1'" type="text" onClick="this.setSelectionRange(0, this.value.length)" @keyup.up.left.right.down="focusInput($event ,data.index, 1)"
				  v-model.number="data.item.count" class="move" @input="checkCount(data.index,$event)">
				</b-form-input>
			</template>
			<template slot="inWrapped" slot-scope="data">
				<span>{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) : 1 }}</span>
			</template>
			<template slot="inWrappedTotal" slot-scope="data">
				<span>{{ data.item.wrapped ? getWrappedItemsAmount(data.item.wrappedItems) * data.item.count : data.item.count }}</span>
			</template>
			<template slot="incomeUsd" slot-scope="data">
				<b-form-input :ref="data.index + '2'" type="text" v-if="ok && section == 'KIRIM'" onClick="this.setSelectionRange(0, this.value.length)" @keyup.up.left.right.down="focusInput($event ,data.index, 2)"
				  v-model="data.item.incomingPriceUsd" class="move" :disabled="data.item.wrapped">
				</b-form-input>
				<div v-else-if="section == 'KIRIM'" data-toggle="tooltip" :title="$t('pricing.update')" @click="OkFunction(data.index + '2')">
					<div class="inputWidth"> {{data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0 |
							currency({
							symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
					</div>
				</div>
				<div v-else class="inputWidth"> {{data.item.incomingPriceUsd ? data.item.incomingPriceUsd : 0 |
						currency({
						symbol: userDepCurrencyName, symbolPosition: 'back',
						thousandsSeparator: ' '
						})}}
				</div>
			</template>
			<template slot="newUzb" slot-scope="data">
				<b-form-input :ref="data.index + '3'" type="text" v-if="ok && section == 'KIRIM' && data.item.wrapped" onClick="this.setSelectionRange(0, this.value.length)" @keyup.up.left.right.down="focusInput($event ,data.index, 3)"
				  v-model="data.item.priceUzs" class="move">
				</b-form-input>
				<div v-else-if="section == 'KIRIM' && !data.item.wrapped" data-toggle="tooltip" :title="$t('pricing.update')" @click="OkFunction(data.index + '3')">
					<div class="inputWidth"> {{data.item.priceUzs ? data.item.priceUzs : 0 | currency({
							symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
					</div>
				</div>
				<div class="inputWidth" v-else> {{depSaleType && depSaleType === 'WHOLE' ? data.item.priceWholesale : data.item.priceUzs | currency({
						symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
						thousandsSeparator: ' '
						})}}
				</div>
			</template>
			<template slot="newUsd" slot-scope="data">
				<b-form-input :ref="data.index + '4'" type="text" v-if="ok" @keyup.up.left.right.down="focusInput($event ,data.index, 4)" onClick="this.setSelectionRange(0, this.value.length)" v-model="data.item.priceUsd" class="move">
				</b-form-input>
				<div v-else data-toggle="tooltip" :title="$t('pricing.update')" @click="OkFunction(data.index + '4')">
					<div class="inputWidth"> {{data.item.priceUsd ? data.item.priceUsd : 0 | currency({
							symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
							thousandsSeparator: ' '
							})}}
					</div>
				</div>
			</template>
			<template slot="priceUsd" slot-scope="data">
				{{ data.value * data.item.count }}$ (USD)
			</template>
			<template slot="priceUzs" slot-scope="data">
				{{ (depSaleType && depSaleType === 'WHOLE' ? data.item.priceWholesale : data.item.priceUzs) * data.item.count | currency({
					symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
					thousandsSeparator: ' '
					}) }}
			</template>
			<template slot="itemIncomeTotal" slot-scope="data">
				{{ data.item.incomingPriceUsd * data.item.count | currency({
					symbol: computedDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
					thousandsSeparator: ' '
					}) }}
			</template>
			<template slot="actions" slot-scope="data">
				<b-link v-if="section == 'KIRIM' && data.item.wrapped" :key="data.index + 'view'" variant="outline" @click.prevent="viewWrappedItem(data.item, data.index)">
					<i class="fa fa-eye"></i>
				</b-link>
				<b-link :key="data.index + 'delete'" :id="'popOverDelete'+data.index" @click="showConfirm(data.index)">
					<i class="fa fa-trash"></i>
				</b-link>
				<b-popover :key="data.index + 'popover'" :target="'popOverDelete'+data.index" placement="bottom" :ref="'popover'+data.index" class="refDeleteConfirm inSidebar">
					<template slot="title">
						<b-button @click="closeConfirm(data.index)" class="close" aria-label="Close" style="margin-left: 5px">
							<span class="d-inline-block" aria-hidden="true">&times;</span>
						</b-button>
						{{ $t('want_to_delete?') }}
					</template>

					<div>
						<div class="row mt-1">
							<div class="col-6">
								<b-button variant="outline-danger" size="sm" block @click="closeConfirm(data.index)"> {{ $t('actions.no') }}
								</b-button>
							</div>
							<div class="col-6">
								<b-button variant="outline-success" size="sm" block @click="remove(data.index)">{{
										$t('actions.yes') }}
								</b-button>
							</div>
						</div>
					</div>
				</b-popover>
			</template>
		</b-table>

		<b-modal v-model="openViewProductModal" id="modal-lg" hide-footer size="xl" :title="$t('sidebar.warehouse-management.product-view')" no-close-on-backdrop no-close-on-esc>

			<b-table class="generalTableClass" striped="striped" bordered="bordered" small="small" fixed="fixed" :items="wrappedItems" :fields="computedFieldsForTransfer" responsive="sm">
				<template slot="index" slot-scope="data">
					{{ data.index + 1 }}
				</template>
				<template slot="incomeUzs" slot-scope="data">
					<b-form-group breakpoint="lg" class="required">
						<b-input-group size="sm">
							<b-form-input :required="true" size="sm" @focus="$event.target.select()" type="number" v-model.number="data.item.incomingPriceUsd" class="ml-1" :placeholder="$t('incomes.create.incoming-price')"></b-form-input>
							<b-input-group-addon>
								<b-button disabled size="sm">{{ computedDepCurrencyName }}</b-button>
							</b-input-group-addon>
						</b-input-group>
					</b-form-group>
				</template>
			</b-table>
		</b-modal>
	</div>
</div>
</template>

<script>
import {mapState} from 'vuex'

export default {
	name: 'ItemList',

	props: {
		depSaleType: {type: String},
		items: {
			type: Array,
			default: null
		},
		section: {
			type: String,
			default: 'KIRIM'
		},
		mode: {
			type: String,
			default: 'create',
		},
		depCurrencyName: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			currentIndex: null,
			openViewProductModal: false,
			wrappedItems: [],
			computedFieldsForTransfer: [{
					key: 'artikul',
					label: this.$t('goods.artikul'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'colorName',
					label: this.$t('goods.color'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'size',
					label: this.$t('goods.size'),
					'class': 'incomeItemSize',
					visible: true,
					changebale: true
				},
				{
					key: 'name',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					visible: true,
					changebale: true
				},
				{
					key: 'amount',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},

				{
					key: 'barcode',
					label: this.$t('goods.barcode'),
				},
				{
					key: 'priceUzs',
					label: `${this.$t('incomes.create.price')} (Сумма)`,
					'class': 'td-30',
					visible: true,
					changebale: true
				},


			],
			customCount: 1,
			fields: [{
					key: 'id',
					label: '№',
				},
				{
					key: 'artikul',
					label: this.$t('goods.artikul'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'color',
					label: this.$t('goods.color'),
					'class': 'incomeItemArtikul',
					visible: true,
					changebale: true
				},
				{
					key: 'size',
					label: this.$t('goods.size'),
					'class': 'incomeItemSize',
					visible: true,
					changebale: true
				},
				{
					key: 'itemName',
					label: this.$t('incomes.create.product'),
					'class': 'not-first',
					visible: true,
					changebale: true
				},
				{
					key: 'sectorId',
					label: "Sector",
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'count',
					label: this.$t('incomes.create.count'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'realBalance',
					label: this.$t('pos.inventoryQty'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'incomeUsd',
					label: this.$t('prices.item.sum'),
				},
				{
					key: 'newUzb',
					label: this.section == 'KIRIM' ? this.$t('prices.item.sum-new') : 'Цена (штук)',

				},
				{
					key: 'itemIncomeTotal',
					label: this.$t('money.incomeUzsTotal'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					key: 'priceUzs',
					label: this.$t('sale.sum'),
					'class': 'td-30',
					visible: true,
					changebale: true
				},
				{
					label: `${this.$t('incomes.actions')}`,
					key: 'actions',
					'class': 'table_actions',
					visible: true,
					changebale: false
				}

			],
			ok: false,
		}
	},
	computed: {
		...mapState(['userDepCurrencyName']),
		...mapState('warehouse', [
			'sectors'
		]),
		computedDepCurrencyName() {
			return this.depCurrencyName || this.userDepCurrencyName;
		},
		dataSource() {
			return this.items;
		},
		columns() {
			this.fields.splice(5, 1);
			this.fields.splice(7, 1);
			this.fields.splice(8, 1);
			return this.fields;
		},
		hasWrappedItem() {
			if (this.items) {
				let foundIndex = this.items.findIndex(el => el.wrapped == true);
				if (foundIndex > -1) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}
	},
 	methods: {
		getWrappedItemsAmount(wrappedItems) {
			let inWrappedAmount = 0;
			if (wrappedItems) {
				wrappedItems.forEach(item => inWrappedAmount += item.amount)
			}
			return inWrappedAmount;
		},
		saveWrappedModal(wrappedItems) {
			this.dataSource[this.currentIndex].incomingPriceUsd = 0;
			wrappedItems.forEach(el => {
				if (el.incomingPriceUsd) {
					this.dataSource[this.currentIndex].incomingPriceUsd += el.incomingPriceUsd > 0 ? el.incomingPriceUsd * el.amount : 0;
				}
			})
			this.openViewProductModal = false;
		},
		closeWrappedModal() {
			this.openViewProductModal = false;
		},
		viewWrappedItem(item, index) {
			this.currentIndex = index;
			this.wrappedItems = item.wrappedItems ? item.wrappedItems : [];
			this.openViewProductModal = true;
		},
		setSector(sectorId) {
			if (sectorId) {
				let temp = [];
				for (let i = 0; i < this.sectors.length; i++) {
					if (sectorId === this.sectors[i].id) {
						temp = this.sectors[i].name;
					}

				}
				return temp
			} else {
				return 0
			}
		},
		async checkCount(index, $event) {
			if (this.dataSource[index].realBalance < $event && this.section !== 'KIRIM') {
				this.dataSource[index].count = await this.dataSource[index].realBalance;
				this.$vs.notify({
					title: "Количество",
					text: 'Проверьте количество товаров!',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		showConfirm(item) {
			let refName = 'popover' + item;
			this.$refs[refName].$emit('open')
		},
		closeConfirm(item) {
			let refName = 'popover' + item;
			this.$refs[refName].$emit('close')
		},
		remove(index) {
			let refName = 'popover' + index;
			this.$refs[refName].$emit('close')
			this.$emit('remove', index)
		},
		focusInput($event, index, inputOrder) {
			let lastIndex = this.dataSource.length - 1;
			if ($event.keyCode == 37) {
				if (inputOrder == 1 && index == 0) {
					return 1
				}
				if (inputOrder == 1 && index != 0) {
					const refName = (index - 1).toString() + '3'
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				if (inputOrder == 3) {
					const refName = index.toString() + (parseInt(inputOrder) - 1).toString()
					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				const refName = index.toString() + (parseInt(inputOrder) - 1).toString()

				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
				this.$refs[refName].$el.focus()
			}
			if ($event.keyCode == 39) {
				if (inputOrder == 3 && lastIndex == index) {
					return 1
				}
				if (inputOrder == 3 && lastIndex != index) {
					const refName = (index + 1).toString() + '1'

					this.$refs[refName].$el.focus()
					this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
					return
				}
				const refName = index.toString() + (parseInt(inputOrder) + 1).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}
			if ($event.keyCode == 38) {
				if (index == 0) {
					return 1
				}
				const refName = (index - 1).toString() + (inputOrder).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}
			if ($event.keyCode == 40) {
				if (index == lastIndex) {
					return 1
				}
				const refName = (index + 1).toString() + (inputOrder).toString()
				this.$refs[refName].$el.focus()
				this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			}

		},
		async OkFunction(refName) {
			await this.changeOk();
			await this.focusRef(refName)
		},
		changeOk() {
			this.ok = true;
			return true;
		},
		focusRef(refName) {
			this.$refs[refName].focus();
			this.$refs[refName].$el.setSelectionRange(0, this.$refs[refName].$el.value.length)
			return true;
		},
	}
}
</script>

<style scoped>
th {
	padding: 2px;
}
</style>
